import { pullAllBy, round, unionBy } from 'lodash'

export const generateDynamicHeaders = (data, groups, t, nameField, columnName, checkEl = false, nameElementsArr) => {
	if (data && data?.[groups]) {
		const dataGroupArray = [...data[groups]]
		if(checkEl) {
			nameElementsArr.forEach(nameEl => {
				const newEl = dataGroupArray.find(item => item.name === nameEl)
				if(newEl) {
					pullAllBy(dataGroupArray, [{ name: nameEl }], 'name')
					dataGroupArray.unshift(newEl)
				} else {
					dataGroupArray.unshift({ name: nameEl })
				}
			})
		}
		return dataGroupArray.reduce((acc, header, i) => {
			acc.push({
				caption: `${header.name} ${t(columnName)}`,
				dataField: `${groups}[${i}].${nameField}`,
				alignment: 'right',
				width: 180,
				summary: {
					summaryType: 'sum'
				},
				localFormat: { type: 'float' }
			})
			return acc
		}, [])
	}
}

export const generateDynamicDoubleHeaders = (data, groups, t, nameField1, nameField2, columnName1, columnName2, withPercent = false) => {
	if (data && data?.[groups]) {
		const unionArr = withPercent ? unionBy(data[groups], 'percent') : data[groups]
		return unionArr.reduce((acc, header, i) => {
			acc.push({
				caption: withPercent ? `${(round(header.percent, 2)) || '0'}% ${t(columnName1)}` : `${header.name} ${t(columnName1)}`,
				dataField: `${groups}[${i}].${nameField1}`,
				alignment: 'right',
				width: withPercent ? 90 : 180,
				summary: {
					summaryType: 'sum'
				},
				localFormat: { type: 'float' }
			}, {
				caption: withPercent ? `${round(header.percent, 2) || '0'}% ${t(columnName2)}` : `${header.name} ${t(columnName2)}`,
				dataField: `${groups}[${i}].${nameField2}`,
				alignment: 'right',
				width: withPercent ? 90 : 180,
				summary: {
					summaryType: 'sum'
				},
				localFormat: { type: 'float' }
			})
			return acc
		}, [])
	}
}

export const generateDynamicCurrencyHeaders = (data, groups, t, nameField1, nameField2, nameField3, columnName1, columnName2, columnName3, mainCurrency) => {
	if (data && data?.[groups]) {
		const isMultiCurrency = data[groups].length > 1
		return data[groups].reduce((acc, header, i) => {
			acc.push({
				caption: `${isMultiCurrency ? header.name : ''} ${t(columnName1)} ${mainCurrency}`, // closing_section.fields.amount_converted
				dataField: `${groups}[${i}].${nameField1}`, // amountConverted
				alignment: 'right',
				width: 150,
				summary: {
					summaryType: 'sum'
				},
				localFormat: { type: 'float' }
			}, {
				caption: `${header.name} ${t(columnName2)}`, // closing_section.fields.currency_present
				dataField: `${groups}[${i}].${nameField2}`, // present
				alignment: 'right',
				width: 80,
				summary: {
					summaryType: 'sum'
				},
				localFormat: { type: 'float' }
			}, {
				caption: `${t(columnName3)} ${header.name}`, // closing_section.fields.difference_in
				dataField: `${groups}[${i}].${nameField3}`, // difference
				alignment: 'right',
				width: 150,
				summary: {
					summaryType: 'sum'
				},
				localFormat: { type: 'float' }
			})
			return acc
		}, [])
	}
}


